export enum SortDirection {
    ASC = 'ASC',
    DESC = 'DESC',
}

export const getDirection = (sort: SortDirection) => (sort === SortDirection.ASC ? 1 : -1);
